import React from 'react'

import TextField from '@mui/material/TextField'
import { msToTime, timeToMs } from '../../utils/dateUtils'

interface TimeFieldProps {
  timeValue: number
  disabled?: boolean
  minValue: number
  maxValue: number
  label: string
  autoFocus?: boolean
  onBlur: (newValue: number) => void
  onEnter?: (newValue: number) => void
}

const TimeField = (props: TimeFieldProps): JSX.Element => {
  const [timeString, setTimeString] = React.useState<string>(msToTime(props.timeValue))

  const isValidTime = (newValue: string): boolean => {
    return (
      // allow both 00:00 and 0:00 formats
      new RegExp('^[0-5]?[0-9]:[0-5][0-9]$').test(newValue) &&
      timeToMs(newValue) <= props.maxValue &&
      timeToMs(newValue) >= props.minValue
    )
  }

  return (
    <TextField
      sx={{ mr: 2 }}
      disabled={props.disabled}
      size="small"
      variant="outlined"
      placeholder="00:00"
      label={props.label}
      autoFocus={props.autoFocus}
      inputProps={{ maxLength: 5 }}
      value={timeString}
      onChange={(event: React.ChangeEvent<HTMLInputElement>) => setTimeString(event.target.value)}
      onKeyPress={(event: React.KeyboardEvent<HTMLInputElement>): void => {
        const newValue = (event.target as HTMLInputElement).value
        if (event.key === 'Enter' && props.onEnter && isValidTime(newValue)) {
          props.onEnter(timeToMs(newValue))
        }
      }}
      onBlur={(event) => {
        // only update editor length in ms if a valid time is entered
        if (isValidTime(event.target.value)) {
          props.onBlur(timeToMs(event.target.value))
        } else {
          setTimeString(msToTime(props.timeValue))
        }
      }}
    />
  )
}

export default TimeField
